export const SECTION_NATURAL_INPUT = 'builder-natural-input';
